module.exports = __webpack_public_path__ + "Server-Default.Ssh.4f9a5b381ce98a0fa4d4f10c333f591b.hashedasset.svg";